(function () {
  function getProductForm(acceleratedBlock) {
    var productFormComponent = acceleratedBlock.closest('product-form-component');
    return productFormComponent
      ? productFormComponent.querySelector('form[data-type="add-to-cart-form"]')
      : null;
  }

  function ensureBuyItNow(acceleratedBlock) {
    var productForm = getProductForm(acceleratedBlock);
    if (!productForm) return;

    var next = acceleratedBlock.nextElementSibling;
    if (next && next.classList.contains('aviiro-buy-now-button')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button add-to-cart-button aviiro-buy-now-button';
    button.textContent = (window.aviiroStrings && window.aviiroStrings.buyNow) || 'Buy it Now';

    // Deliberately not a <form> — inserting one here would nest it inside
    // Shopify's own product form (invalid HTML), which caused the sticky
    // add-to-cart bar's own form/button lookups to misfire intermittently.
    // A plain button + fetch avoids that entirely.
    button.addEventListener('click', function () {
      if (button.disabled) return;
      button.disabled = true;

      var liveId = productForm.querySelector('input[name="id"]');
      var liveQty = productForm.querySelector('input[name="quantity"]');
      var variantId = liveId ? liveId.value : '';
      var quantity = liveQty && liveQty.value ? liveQty.value : '1';

      // There's no separate "Add to cart" step anymore — this button is the only
      // way an item reaches the cart. If a customer already has this variant in
      // their cart (e.g. they came back after abandoning a previous checkout) and
      // click this again, a plain /cart/add would ADD on top of what's already
      // there, silently doubling the quantity with no cart review screen to catch
      // it. So: check the cart first, and SET the line to the quantity shown in
      // the selector (via /cart/change) instead of incrementing, when it's
      // already present.
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var existing = (cart.items || []).find(function (item) {
            return String(item.variant_id) === String(variantId);
          });

          if (existing) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: quantity }),
            });
          }

          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', quantity);
          return fetch('/cart/add', { method: 'POST', body: formData });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          button.disabled = false;
        });
    });

    acceleratedBlock.insertAdjacentElement('afterend', button);
  }

  // Reflects the cart's actual quantity for this variant into the quantity
  // selector, so returning from an abandoned checkout shows the real current
  // cart state instead of a blank "1" the customer might unknowingly add on
  // top of. Deliberately NOT called from the mutation-triggered ensureAll()
  // below — this only runs at page load and when restoring from bfcache, so
  // it never fights the quantity selector's own +/- clicks (which also
  // mutate the DOM and would otherwise re-trigger this mid-interaction).
  function syncQuantityWithCart(acceleratedBlock) {
    var productForm = getProductForm(acceleratedBlock);
    if (!productForm) return;

    var liveId = productForm.querySelector('input[name="id"]');
    var liveQty = productForm.querySelector('input[name="quantity"]');
    if (!liveId || !liveQty) return;

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var existing = (cart.items || []).find(function (item) {
          return String(item.variant_id) === String(liveId.value);
        });
        if (!existing) return;

        liveQty.value = existing.quantity;
        liveQty.dispatchEvent(new Event('change', { bubbles: true }));
      })
      .catch(function () {
        // Cart fetch failing shouldn't block anything else on the page.
      });
  }

  function syncAllQuantities() {
    document.querySelectorAll('.accelerated-checkout-block').forEach(syncQuantityWithCart);
  }

  function ensureAll() {
    document.querySelectorAll('.accelerated-checkout-block').forEach(ensureBuyItNow);
  }

  function reenableButtons() {
    document.querySelectorAll('.aviiro-buy-now-button').forEach(function (button) {
      button.disabled = false;
    });
  }

  function init() {
    ensureAll();
    syncAllQuantities();

    // Shopify morphs buy-buttons areas on variant change (to refresh price /
    // availability), which can re-render .accelerated-checkout-block and drop
    // whatever sits next to it. Hiding the wallet button is handled permanently in
    // CSS, but watch the whole page and re-insert the Buy it Now button too in case
    // a morph ever wipes it out — covers every buy box on the page (product page,
    // homepage purchase section, etc.), not just one hardcoded section.
    var observer = new MutationObserver(ensureAll);
    observer.observe(document.body, { childList: true, subtree: true });

    // When a customer clicks this button it gets disabled to prevent a double
    // submit, then we navigate to checkout. If they hit the browser's back
    // button, some browsers restore the page from cache (bfcache) with that
    // disabled state still baked in, leaving the button looking dead until a
    // manual refresh. Re-enable on restore, and re-sync quantity too since the
    // cart may have changed while they were on checkout.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      reenableButtons();
      syncAllQuantities();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
